<template>
  <div>
    <b-card>
      <template #header>
        <div class="d-flex justify-content-between align-items-center">
          <h4 class="mb-0">
            Mensualidades con Adjunto
          </h4>
          <div class="ml-auto">
            <b-button
              variant="primary"
              size="sm"
              class="ml-4"
              @click="query"
            >
              <feather-icon
                icon="RefreshCwIcon"
                size="14"
                class="mr-50"
              />
              Actualizar
            </b-button>
          </div>
        </div>
      </template>

      <b-table
        responsive
        :fields="fields"
        :items="items"
        :busy="isBusy"
        show-empty
        empty-text="No hay mensualidades con adjunto"
        head-variant="dark"
        striped
        hover
      >
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner variant="primary" />
          </div>
        </template>

        <template #cell(index)="data">
          {{ data.index + 1 }}
        </template>

        <template #cell(codigo)="data">
          <strong>{{ data.value }}</strong>
        </template>

        <template #cell(deposit_date)="data">
          {{
            formatDate(
              data.item.deposit_date ||
                data.item.fecha ||
                data.value
            )
          }}
        </template>

        <template #cell(origin_bank_name)="data">
          {{ data.value || '-' }}
        </template>

        <template #cell(destination_bank)="data">
          {{ formatDestinationBank(data.item) }}
        </template>

        <template #cell(saldo)="data">
          <strong class="text-danger">
            {{ formatMoneda(data.value) }}
          </strong>
        </template>

        <template #cell(file)="data">
          <b-button
            v-if="
              data.item.file ||
                data.item.archivo_url ||
                data.item.archivo
            "
            variant="primary"
            size="sm"
            :href="
              data.item.file ||
                data.item.archivo_url ||
                data.item.archivo
            "
            target="_blank"
          >
            <feather-icon
              icon="ExternalLinkIcon"
              size="14"
              class="mr-1"
            />
          </b-button>
          <span v-else>-</span>
        </template>

        <template #custom-foot>
          <tr class="bg-light">
            <td
              colspan="5"
              class="text-right"
            >
              <strong>TOTAL:</strong>
            </td>
            <td class="text-right">
              <strong class="text-primary">{{ total }}</strong>
            </td>
            <td colspan="4" />
          </tr>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import { BButton, BCard, BSpinner, BTable } from 'bootstrap-vue'

export default {
    components: {
        BCard,
        BTable,
        BButton,
        BSpinner,
    },
    data() {
        return {
            isBusy: false,
            userData: JSON.parse(localStorage.getItem('userData')),
            items: [],
            fields: [
                { key: 'index', label: '#' },
                { key: 'codigo', label: 'Código' },
                { key: 'tiponom', label: 'Tipo' },
                { key: 'deposit_date', label: 'Fecha del Depósito' },
                { key: 'detalle', label: 'Concepto' },
                { key: 'saldo', label: 'Balance', class: 'text-right' },
                { key: 'origin_bank_name', label: 'Banco Origen' },
                { key: 'destination_bank', label: 'Banco Destino' },
                { key: 'deposit_reference', label: 'Referencia de Depósito' },
                { key: 'file', label: 'Archivo', class: 'text-center' },
            ],
        }
    },
    computed: {
        total() {
            return this.items
                .reduce((sum, item) => sum + (parseFloat(item.saldo) || 0), 0)
                .toFixed(2)
        },
    },
    created() {
        this.query()
    },
    methods: {
        query() {
            this.isBusy = true
            this.$http
                .get('/mensualidades-con-adjunto')
                .then((response) => {
                    this.isBusy = false
                    this.items = response.data.data || []
                })
                .catch((error) => {
                    this.isBusy = false
                    this.$swal({
                        title: 'Error',
                        text:
                            error.response?.data?.error ||
                            'Error al cargar las mensualidades con adjunto',
                        icon: 'error',
                        customClass: {
                            confirmButton: 'btn btn-danger',
                        },
                        buttonsStyling: false,
                    })
                })
        },

        formatDate(value) {
            if (!value || value === null || value === undefined || value === '')
                return '-'
            try {
                // Si ya viene en formato YYYY-MM-DD, devolverlo directamente sin procesar
                if (
                    typeof value === 'string' &&
                    /^\d{4}-\d{2}-\d{2}$/.test(value)
                ) {
                    return value
                }
                // Si viene en formato ISO con hora, extraer solo la fecha
                if (typeof value === 'string' && value.includes('T')) {
                    return value.split('T')[0]
                }
                // Para otros formatos, intentar parsear
                const date = new Date(value)
                if (Number.isNaN(date.getTime())) return '-'
                const day = String(date.getDate()).padStart(2, '0')
                const month = String(date.getMonth() + 1).padStart(2, '0')
                const year = date.getFullYear()
                return `${year}-${month}-${day}`
            } catch (error) {
                return '-'
            }
        },

        formatMoneda(value) {
            if (!value) return '0.00'
            const val = parseFloat(value).toFixed(2).replace(',', '.')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        },

        formatDestinationBank(item) {
            if (!item) return '-'
            const bank = item.destination_bank_name || ''
            const account = item.destination_bank_account || ''
            if (bank && account) {
                return `${bank} - ${account}`
            }
            if (bank) return bank
            if (account) return account
            return '-'
        },
    },
}
</script>

<style lang="scss" scoped>
.card {
    border: none;
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.card-header {
    padding: 1rem 1.5rem !important;
}

.table {
    thead {
        th {
            background: linear-gradient(
                135deg,
                #1e293b 0%,
                #334155 100%
            ) !important;
            color: #fff !important;
            font-weight: 600;
        }
    }
}
</style>
